import { AlkLogger } from '@alk/core';
import { FlushableOrdersTransaction, OrdersTransaction } from '.';
import { IBlotterUpdate, ORDER_KEY } from '../../interfaces';
import { non, referenceEqualerCurried } from '../../helpers/object-utils';

export const isBlotterTransaction = (update: FlushableOrdersTransaction): update is OrdersTransaction => !update.flush;

export const accumulateOrders = (
    { allOrders: orders }: IBlotterUpdate,
    update: FlushableOrdersTransaction): IBlotterUpdate => {

    if (isBlotterTransaction(update)) {

        update.newItems?.forEach(newOrder => {
            if (orders.has(newOrder.orderId)) {
                AlkLogger.error(`[ORDER_AGGREGATOR#accumulateOrders] get new order with already presented id ${ newOrder.orderId }`);
            } else {
                orders.set(newOrder.orderId, newOrder);
            }
        });

        update.updated?.forEach(updOrder => {

            if (!orders.has(updOrder.orderId)) {
                AlkLogger.error(`[ORDER_AGGREGATOR#accumulateOrders] get order update for id ${ updOrder.orderId }, but not found order`);
                return;
            }

            const orderForUpdate = orders.get(updOrder.orderId);

            Object.keys(updOrder)
                .filter(non(referenceEqualerCurried(ORDER_KEY)))
                .forEach(key => orderForUpdate[ key ] = updOrder[ key ]);
        });

        update.deletedKeys?.forEach(orderId => {
            if (!orders.has(orderId)) {
                AlkLogger.error(`[ORDER_AGGREGATOR#accumulateOrders] get deleted order with not presented id ${ orderId }`);
            }

            orders.delete(orderId);
        });
    } else {
        orders.clear();
    }

    return {
        ...update,
        allOrders: orders,
    };
};
